import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { POLICY_URL_MAX, POLICY_URLS_HINT } from './SmsRegistrationForm';

// Settings > Texting and Email, SMS Phase 6c: the owner's own privacy policy and
// terms pages, changed on their own once the rest of the business details are
// with the carriers. Shown while the server says so
// (provisioning.policyUrlsEditable): until the campaign is submitted, or after
// the registry rejected it, when SnowTrack's Retry sends the new pages.
// PUT /api/sms/registration/policy-urls; both blank goes back to the pages
// SnowTrack hosts.
const API = `${process.env.REACT_APP_API_URL}/api/sms`;

function SmsPolicyUrls({ onSaved }) {
  const [form, setForm] = useState({ privacyPolicyUrl: '', termsUrl: '' });
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState('');
  const [errorField, setErrorField] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let live = true;
    axios.get(`${API}/registration`)
      .then(({ data }) => {
        if (!live || !data.registration) return;
        setForm({ privacyPolicyUrl: data.registration.privacyPolicyUrl || '', termsUrl: data.registration.termsUrl || '' });
        setLoaded(true);
      })
      .catch(() => {});
    return () => { live = false; };
  }, []);

  // Nothing stored yet: the full form is where they start.
  if (!loaded) return null;

  const set = (name) => (e) => setForm((f) => ({ ...f, [name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    setErrorField(null);
    try {
      const { data } = await axios.put(`${API}/registration/policy-urls`, form);
      const r = data.registration || {};
      setForm({ privacyPolicyUrl: r.privacyPolicyUrl || '', termsUrl: r.termsUrl || '' });
      if (onSaved) await onSaved(r);
    } catch (err) {
      setError(err.response?.data?.error || 'Your policy pages could not be saved. Try again.');
      setErrorField(err.response?.data?.field || null);
    } finally {
      setBusy(false);
    }
  };

  const input = (name, label) => (
    <div style={{ marginBottom: '10px' }}>
      <label className="form-label" htmlFor={`sms-policy-${name}`}>{label}</label>
      <input id={`sms-policy-${name}`} className="form-input" type="url" maxLength={POLICY_URL_MAX} placeholder="https://"
        value={form[name]} onChange={set(name)} aria-invalid={errorField === name} data-testid={`sms-policy-${name}`} />
    </div>
  );

  return (
    <form onSubmit={submit} data-testid="sms-policy-urls-form" style={{ marginTop: '12px' }}>
      <h3 style={{ fontSize: '1rem', margin: '0 0 4px' }}>Your policy pages</h3>
      <p className="text-muted" style={{ fontSize: '0.8125rem', margin: '0 0 12px' }}>{POLICY_URLS_HINT}</p>
      {error && <div className="alert alert-error">{error}</div>}
      <fieldset style={{ border: 'none', padding: 0, margin: 0 }} disabled={busy}>
        {input('privacyPolicyUrl', 'Texting privacy policy page')}
        {input('termsUrl', 'Texting terms page')}
        <button type="submit" className="btn btn-secondary" disabled={busy} data-testid="sms-policy-submit">
          {busy ? 'Saving...' : 'Save policy pages'}
        </button>
      </fieldset>
    </form>
  );
}

export default SmsPolicyUrls;
